import React from 'react';
import { Box, Input, TextArea } from '@opendoor/bricks/core';
import { CustomInputLabel } from 'sellDirect/components/closingDash/form/CustomInputLabel';

export type FormTextInputProps = {
  content?: string | null;
  inputName: string;
  inputType?: 'singleLine' | 'multiLine';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onUpdate: (id: string, value: any) => void;
  placeholder?: string;
  disabled?: boolean;
  title: string;
  subtitle?: string;
};

/**
 * Renders a text input for closing forms.
 *
 * component-test-check-ignore
 */
export const FormTextInput: React.FC<FormTextInputProps> = ({
  content,
  inputName,
  inputType,
  onUpdate,
  title,
  subtitle,
  placeholder,
  disabled,
}) => (
  <Box my={6}>
    {inputType === 'multiLine' ? (
      <>
        <CustomInputLabel
          id={inputName}
          title={title}
          subtitle={subtitle}
          titleFontSize="s1"
          titleFontWeight="semibold"
          mb={3}
        />
        {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
        <TextArea
          analyticsName={`cake-closing-${inputName}`}
          content={content || ''}
          onChange={(_event, name, value) => onUpdate(name, value)}
          name={inputName}
          unboundedWidth
          aria-labelledby={inputName}
        />
      </>
    ) : (
      <Input
        analyticsName={`cake-closing-${inputName}`}
        disabled={disabled}
        required
        type="text"
        aria-labelledby={`input-${inputName}`}
        id={`input-${inputName}`}
        name={inputName}
        value={content || ''}
        onChange={(_event, value) => onUpdate(inputName, value)}
        placeholder={placeholder}
        data-testid={`${inputName}-input`}
        unboundedWidth
        label={`${title} `}
        labelStyles={{ marginBottom: 3 }}
      />
    )}
  </Box>
);
